import { Fab } from "@material-ui/core";
import MapIcon from "@material-ui/icons/Map";

import React from "react";

export default function MapSwitcher({
  toggleMap,
  isLive
}: {
  toggleMap: () => void;
  isLive: boolean;
}) {
  return (
    <Fab
      variant="extended"
      sx={{
        backgroundColor: "#000000",
        color: "#ffffff",
        padding: "12px 16px",
        height: "auto",
        position: "fixed",
        right: 24,
        bottom: 32,
        "&:hover": {
          backgroundColor: "rgba(0,0,0,0.9)"
        }
      }}
      onClick={toggleMap}
    >
      <MapIcon sx={{ mr: 1 }} />
      {isLive ? "Track Live" : "Map"}
    </Fab>
  );
}
